import { render } from "./EditInfo.vue?vue&type=template&id=53a4811d&scoped=true"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"

import "./EditInfo.vue?vue&type=style&index=0&id=53a4811d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a4811d"]])

export default __exports__